import React, { PureComponent } from 'react';
import Auth from '../../../libs/Auth';

class AccountsView extends PureComponent {
  constructor(props){
    super(props);
    this.state = {
      expanded: {}
    }
  }
  toggle(id){
    const { expanded } = this.state;
    this.setState({
      expanded: {
        ...expanded,
        [id]: !expanded[id]
      }
    });
  }
  render() {
    let {
      accounts,
      addAccount,
      importListings,
      importTransactions,
    } = this.props;


    return (
      <div className="admin-accounts-view page">
        <h2>Accounts</h2>
        <div className="actions">
          <button onClick={addAccount} className="button" type="button">Add Ebay Account</button>
        </div>
        <table>
          <thead>
          <tr>
            <th>User Id</th>
            <th>Email</th>
            <th>Listings Last Updated</th>
            <th>Transactions Last Updated</th>
            <th>actions</th>
            {/*<th></th>*/}
          </tr>
          </thead>
          {accounts.map((account, i)=>(
            <tbody key={account._id}>
              <tr className={i%2 ? 'even' : 'odd'}>
                <td>{account.userId}</td>
                <td>{account.email}</td>
                <td>{account.listingsUpdated && (new Date(account.listingsUpdated)).toLocaleString()}</td>
                <td>{account.transactionsUpdated && (new Date(account.transactionsUpdated)).toLocaleString()}</td>
                <td>
                  <div className="action-buttons">
                    <button type="button" onClick={() => importListings(account.userId)}>
                      <i className="fi-download size-18"></i> Listings
                    </button>
                    <button type="button" onClick={() => importTransactions(account.userId)}>
                      <i className="fi-download size-18"></i> Transactions
                    </button>
                  </div>
                </td>
                {/*<td>
                  <div className="action-buttons">
                    <button onClick={() => this.toggle(account._id)}><i className="fi-arrows-out size-18"></i> view more</button>
                  </div>
                </td>*/}
              </tr>
              {this.state.expanded[account._id] && (
                <tr>
                  <td colSpan="2">
                    <h2>
                      Details
                    </h2>
                  </td>
                </tr>
              )}
            </tbody>

          ))}
        </table>
      </div>
    );
  }
}

export default AccountsView;



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/Accounts/Accounts.view.js